import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/icon-button/icon-button.js';
      import {IconButtonVariant} from '@oicl/openbridge-webcomponents/dist/components/icon-button/icon-button.js';

      export interface Props {
     variant?: IconButtonVariant;
     activated?: boolean;
     cornerLeft?: boolean;
     cornerRight?: boolean;
     activeColor?: boolean;
     wide?: boolean;
     disabled?: boolean;
     progress?: number | undefined;
     hasLabel?: boolean
   }

      
  
      export type {IconButtonVariant} from '@oicl/openbridge-webcomponents/dist/components/icon-button/icon-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcIconButton',
  props: {
    variant: {},
    activated: { type: Boolean },
    cornerLeft: { type: Boolean },
    cornerRight: { type: Boolean },
    activeColor: { type: Boolean },
    wide: { type: Boolean },
    disabled: { type: Boolean },
    progress: {},
    hasLabel: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-icon-button',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})